import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAevCmWWcQkU2fq41lj6dZjQHbnRKIpVuA",
  authDomain: "kyrocapital-e6d98.firebaseapp.com",
  projectId: "kyrocapital-e6d98",
  // Default bucket: team, deal-gallery, blog, deck PDF, etc. Keep in sync with `firebase.json` first storage entry.
  storageBucket: "kyrocapital-e6d98.firebasestorage.app",
  messagingSenderId: "517096993061",
  appId: "1:517096993061:web:d9a64fc444e60a8b92eacc",
  measurementId: "G-529RLGPY9P"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);
/** Cloud Functions (PDF → images, deck session). Region must match `functions/src/index.ts`. */
export const functions = getFunctions(app, 'us-central1');

/** WebP slides only; must match `firebase.json` second `storage` bucket and `functions/src/index.ts` FUND_DECK_PAGES_BUCKET. */
export const FUND_DECK_PAGES_STORAGE_BUCKET = 'kyrocapital-e6d98-fund-deck';

export default app;
